/**
 * Extracts the file name from a Content-Disposition response header.
 * Supports both `filename="..."` and RFC 5987 `filename*=UTF-8''...`.
 * e.g. `attachment; filename="Auswertung.csv"` -> `Auswertung.csv`
 * e.g. `attachment; filename*=UTF-8''Auswertung.csv` -> `Auswertung.csv`
 */
export function getFileNameFromContentDisposition(contentDisposition: string | null): string | undefined {
  if (!contentDisposition) {
    return undefined;
  }
  // Prefer filename*= (RFC 5987 encoded) over filename=
  const encodedMatch = /filename\*=([^']*)'([^']*)'(.+)/i.exec(contentDisposition);
  if (encodedMatch) {
    try {
      return decodeURIComponent(encodedMatch[3]);
    } catch {
      return encodedMatch[3];
    }
  }
  const match = /filename="?([^";]+)"?/i.exec(contentDisposition);
  return match?.[1];
}
